import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { registerUser } from '../../actions/authActions';
import classnames from 'classnames';
import './form.css';
import './utils.css';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const Register = props => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [errors, setErrors] = useState([]);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    if (props.errors) {
      setErrors(props.errors);
    }
  }, [props]);

  const onSubmit = e => {
    e.preventDefault();
    const newUser = {
      name: name,
      email: email,
      phone: phone,
      password: password,
      password2: password2
    };

    props.registerUser(newUser, props.history);
  };

  const CustomButton = React.forwardRef(({ open, ...props }, ref) => (
    <div className="float-register-button">
      <button className="btn btn-primary" ref={ref} {...props}>
        <i
          className="fa fa-sign-in"
          aria-hidden="true"
          style={{
            paddingRight: 7
          }}
        />
        Register
      </button>
    </div>
  ));

  return (
    <div>
      {' '}
      {!props.auth.isAuthenticated && (
        <Popup
          trigger={open => <CustomButton open={open} />}
          modal
          nested
          contentStyle={{ width: '305px', borderRadius: 20 }}
        >
          {close => (
            <div>
              <div className="container-login100">
                <div
                  className="wrap-login100"
                  style={{
                    background: 'linear-gradient( #7579ff, #b224ef)'
                  }}
                >
                  <form
                    className="login100-form validate-form"
                    onSubmit={onSubmit}
                  >
                    <span className="login100-form-logo">
                      <i className="fa fa-home fa-2x" aria-hidden="true" />
                    </span>

                    <span className="login100-form-title p-b-10 p-t-27">
                      Register{' '}
                    </span>

                    <div
                      className="wrap-input100 validate-input"
                      data-validate="Enter full name"
                    >
                      <label htmlFor="exampleInputName">
                        Full name{' '}
                        <small
                          style={{
                            color: 'red',
                            paddingLeft: 10,
                            fontSize: 12
                          }}
                          className=""
                        >
                          {errors.name}
                        </small>
                      </label>
                      <input
                        className={classnames('form-control ', {
                          'is-invalid': errors.name
                        })}
                        type="text"
                        placeholder="Full name"
                        onChange={e => setName(e.target.value)}
                        value={name}
                        error={errors.name}
                      />
                    </div>

                    <div
                      className="wrap-input100 "
                      data-validate="Enter password"
                    >
                      <label htmlFor="exampleInputEmail1">
                        Email address{' '}
                        <small
                          style={{
                            color: 'red',
                            paddingLeft: 10,
                            fontSize: 12
                          }}
                          className=""
                        >
                          {errors.email}
                        </small>
                      </label>

                      <input
                        type="email"
                        error={errors.email}
                        onChange={e => setEmail(e.target.value)}
                        value={email}
                        aria-describedby="emailHelp"
                        placeholder="Enter email"
                        className={classnames('form-control ', {
                          'is-invalid': errors.email
                        })}
                      />
                      <small
                        id="emailHelp"
                        style={{
                          color: 'white'
                        }}
                      >
                        We'll never share your email with anyone else.
                      </small>
                    </div>

                    <div
                      className="wrap-input100 "
                      data-validate="Enter password"
                    >
                      <label htmlFor="exampleInputPhone">
                        What'sApp number{' '}
                        <small
                          style={{
                            color: 'red',
                            paddingLeft: 10,
                            fontSize: 12
                          }}
                          className=""
                        >
                          {errors.phone}
                        </small>
                      </label>

                      <input
                        type="tel"
                        onChange={e => setPhone(e.target.value)}
                        value={phone}
                        error={errors.phone}
                        className={classnames('form-control ', {
                          'is-invalid': errors.phone
                        })}
                        id="exampleInputPhone"
                        placeholder="+27726323434"
                      />
                    </div>

                    <div
                      className="wrap-input100 "
                      data-validate="Enter password"
                    >
                      <label htmlFor="exampleInputPhone">
                        Password{' '}
                        <small
                          style={{
                            color: 'red',
                            paddingLeft: 10,
                            fontSize: 12
                          }}
                          className=""
                        >
                          {errors.password}
                        </small>
                      </label>
                      <input
                        type="password"
                        onChange={e => setPassword(e.target.value)}
                        value={password}
                        error={errors.password}
                        className={classnames('form-control ', {
                          'is-invalid': errors.password
                        })}
                        id="exampleInputPassword"
                        placeholder="Password"
                      />
                    </div>

                    <div
                      className="wrap-input100 "
                      data-validate="Enter password2"
                    >
                      <label htmlFor="exampleInputPassword2">
                        Confirm Password{' '}
                        <small
                          style={{
                            color: 'red',
                            paddingLeft: 10,
                            fontSize: 12
                          }}
                        >
                          {errors.password2}
                        </small>
                      </label>
                      <input
                        type="password"
                        onChange={e => setPassword2(e.target.value)}
                        value={password2}
                        error={errors.password2}
                        className={classnames('form-control ', {
                          'is-invalid': errors.password2
                        })}
                        id="exampleInputPassword2"
                        placeholder="Confirm Password"
                      />
                    </div>

                    <div className="container-login100-form-btn">
                      <button className="login100-form-btn">Register</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </Popup>
      )}
    </div>
  );
};

Register.propTypes = {
  registerUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { registerUser }
)(withRouter(Register));
